import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Modal extends Component {

    handleClose = (e) => {
        e.stopPropagation();
        if (typeof this.props.onClose === 'function') {
            this.props.onClose(this);
        }
    }

    handlePreventClose = (e) => {
        e.stopPropagation();
    }

    render() {
        if(!this.props.show) {
          return null;
        }

        return (
          <div className="modal" onClick={this.handleClose}>
            <div className="wrapper onscreen" onClick={this.handlePreventClose}>
              {this.props.children}

              <div className="footer">
                <button onClick={this.handleClose}>Cerrar</button>
              </div>
            </div>
          </div>
        );
    }

}

Modal.propTypes = {
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool,
  children: PropTypes.node
};

export default Modal;


// WEBPACK FOOTER //
// ./src/modules/memories/Modal.js